import React from "react";
import { connect } from "react-redux";
import ShipCard from "./ShipCard";
import {
  getClientShipCount,
  getClientShipSearch,
} from "../Actions/ClientDashboardAPI";
import "react-datepicker/dist/react-datepicker.css";
import { AutoComplete } from "primereact/autocomplete";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import CountUp from "react-countup";

const searchItem = {
  shipName: "",
  pageSize: 10,
};

class ClientDashboardLibrary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allShipo: 100,
      expiredShips: 100,
      expiringShips: 90,
      filterTitle: "All Ships",
      SelectedFromDate: "",
      SelectedToDate: "",
      searchShips: {
        shipName: "",
        pageSize: 10,
      },
      shipsearch: false,
      EquipmentList: ["A_Equipment1", "B_Equipment2", "C_Equipment"],
    };

    this.SearchShipsData = this.SearchShipsData.bind(this);
    this.ClearSearchField = this.ClearSearchField.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    const { dispatch, ShipClientSuccess } = this.props;
    const { match } = this.props;
    if (match.params.id) {
    }
    dispatch({ type: "SubBannerTitle", data: "Dashboard" });
    dispatch(getClientShipCount(match.params.id ?? null));
    if (ShipClientSuccess) {
      dispatch(
        getClientShipSearch(ShipClientSuccess, 1, match.params.id ?? null)
      );
    } else {
      dispatch(
        getClientShipSearch(this.state.searchShips, 1, match.params.id ?? null)
      );
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch, ShipClientSuccess } = nextProps;
    if (
      ShipClientSuccess &&
      !prevState.shipsearch &&
      ShipClientSuccess !== ""
    ) {
      prevState.searchShips.shipName = ShipClientSuccess.shipName;
      prevState.shipsearch = true;
    }
  }

  SearchShipsData(pageNo) {
    const { dispatch, match } = this.props;
    this.state.shipsearch = false;
    this.setState({});
    dispatch(
      getClientShipSearch(
        this.state.searchShips,
        pageNo,
        match.params.id ?? null
      )
    );
  }

  ClearSearchField() {
    const { dispatch, match } = this.props;
    this.state.shipsearch = false;
    this.props.dispatch({ type: "shipClientSuccess", data: "" });
    let param = { ...searchItem };
    this.setState({ searchShips: param }, () => {
      dispatch(
        getClientShipSearch(this.state.searchShips, 1, match.params.id ?? null)
      );
    });
  }

  handleInputChange(e, field) {
    this.state.searchShips[field] = e.target.value;
    this.setState({
      searchShips: this.state.searchShips,
    });
  }

  suggestMItable(event) {
    let results = this.state.EquipmentList.filter((table) => {
      return table.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
    });
    this.setState({ EquipmentList: results });
  }

  hideSidePanel = () => {
    let user = localStorage.getItem("UserRoles");
    if (user === "consultant") {
      this.props.history.replace(`/Home/SpecialAccess`);
    }
  };

  render() {
    const { showSidePane, clientShipSearch, clientShipCount } = this.props;
    let user = localStorage.getItem("UserRoles");
    return (
      <div className="full-height pt-3">
        {user === "consultant" ? (
          <button
            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mb-3 d-flex align-items-center justify-content-center gap-2"
            onClick={() => this.hideSidePanel()}
          >
            <span className="fs-5 " style={{marginTop:'-2px',marginRight:'2px'}}>&larr;</span>
            <span>Back</span>
          </button>
        ) : (
          ""
        )}
        <div className="row">
          <div className="col-lg-12">
            <div
              className="card card-selector text-center mb-0"
              style={{ cursor: "auto" }}
            >
              <h1>
                {" "}
                <CountUp
                  start={0}
                  end={clientShipCount ? clientShipCount.totalShip : 0}
                  duration={2.0}
                  separator=","
                />
              </h1>
              <h5>Total Ships</h5>
            </div>
          </div>
        </div>
        <div className="row my-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div
                className="card MM-card-header m-auto"
                style={{ backgroundColor: "white" }}
              >
                <div className="card-body">
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    All Ships
                  </h5>
                </div>
              </div>
              <div className="search-filter-box">
                <div className="row" style={{ paddingBottom: "12px" }}>
                  <div className="col-lg-6">
                    <label className="form-label">Ship Name</label>
                    <br></br>
                    <AutoComplete
                      value={this.state.searchShips.shipName}
                      onChange={(e) => this.handleInputChange(e, "shipName")}
                      suggestions={this.state.EquipmentList}
                      completeMethod={this.suggestMItable.bind(this)}
                      name="tableValue"
                      inputClassName="form-control"
                      style={{ display: "block" }}
                      inputStyle={{ borderColor: "#ced4da", height: "38px" }}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label"></label>
                    <br></br>
                    <div
                      className="mt-3 search-btn-col"
                      style={{ textAlign: "end" }}
                    >
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.SearchShipsData(1)}
                      >
                        Search
                      </button>
                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() => this.ClearSearchField()}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {clientShipSearch ? (
          <ShipCard
            arraylist={clientShipSearch.data}
            pageSize={clientShipSearch.pagination.pageSize}
            currentPage={clientShipSearch.pagination.currentPage}
            totalRecords={
              clientShipSearch.pagination.totalcount
                ? clientShipSearch.pagination.totalcount
                : 0
            }
            setUpdatedState={(value) => this.SearchShipsData(value)}
          />
        ) : null}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    clientShipCount: state.ClientDashboardReducer.ClientShipCount,
    clientShipSearch: state.ClientDashboardReducer.ClientShipSearch,
    ShipClientSuccess: state.ClientDashboardReducer.ShipClientSuccess,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientDashboardLibrary);
